import VolumeSlider from '../../volume-slider'

import * as Styled from './styled'
import * as ParentStyled from '../styled'
import { memo } from 'react'

interface IProps {
  hideDivideLine?: boolean
}

const MusicVersioningTopSection: React.FC<IProps> = ({ hideDivideLine }) => {
  return (
    <Styled.TopSection>
      <VolumeSlider />
      {!hideDivideLine && <ParentStyled.DivideLine />}
    </Styled.TopSection>
  )
}

export default memo(MusicVersioningTopSection)
